const actions = {
  
  CONTACT_FORMS_READ_BEGIN: 'CONTACT_FORMS_READ_BEGIN',
  CONTACT_FORMS_READ_SUCCESS: 'CONTACT_FORMS_READ_SUCCESS',
  CONTACT_FORMS_READ_ERR: 'CONTACT_FORMS_READ_ERR',

  CONTACT_FORM_DELETE_BEGIN: 'CONTACT_FORM_DELETE_BEGIN',
  CONTACT_FORM_DELETE_SUCCESS: 'CONTACT_FORM_DELETE_SUCCESS',
  CONTACT_FORM_DELETE_ERR: 'CONTACT_FORM_DELETE_ERR',

  CONTACT_FORM_READ_BEGIN: 'CONTACT_FORM_READ_BEGIN',
  CONTACT_FORM_READ_SUCCESS: 'CONTACT_FORM_READ_SUCCESS',
  CONTACT_FORM_READ_ERR: 'CONTACT_FORM_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.CONTACT_FORMS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.CONTACT_FORMS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.CONTACT_FORMS_READ_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.CONTACT_FORM_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.CONTACT_FORM_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.CONTACT_FORM_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.CONTACT_FORM_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.CONTACT_FORM_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.CONTACT_FORM_READ_ERR,
      err,
    };
  },

};

export default actions;
